<template>
    <div id="booking-wrap">

        <div v-if="!completed" class="row justify-content-center">
            <div class="col-md-22 col-lg-20 col-xl-18">

                <ul class="juh-stepper">

                    <li class="juh-stepper-step" :class="{active: !selected && !completed}" @click="selected=null;completed=false">
                        <div class="juh-stepper-btn">
                            <span class="juh-stepper-label">Paket auswählen</span>
                            <span class="juh-stepper-number">1</span>
                        </div>
                    </li>

                    <li class="juh-stepper-line"></li>

                    <li class="juh-stepper-step" :class="{active: selected}">
                        <div class="juh-stepper-btn">
                            <span class="juh-stepper-label">Event Details</span>
                            <span class="juh-stepper-number">2</span>
                        </div>
                    </li>

                </ul>

            </div>
        </div>

        <form v-if="!completed">

            <div class="row" v-if="packages.length > 0 && selected === null">

                <div class="d-flex" :class="itemClass" v-for="pkg in packages" v-bind:key="pkg.id">

                    <label class="card w-100 mb-4" :for="'package-' + pkg.id" :title="pkg.title.rendered">

                        <img class="card-img-top" :src="pkg.image || fallback_image" :alt="pkg.title.rendered" :title="pkg.title.rendered">

                        <div class="card-body">

                            <h3 class="card-title" v-html="pkg.title.rendered"></h3>
                            <div class="cad-text" v-html="pkg.content.rendered"></div>

                        </div>

                        <input type="radio" v-model="selected" name="package" :value="pkg" :id="'package-' + pkg.id" class="sr-only">

                    </label>

                </div>

            </div>

            <div class="row justify-content-center" v-if="selected">
                <div class="col-md-10">

                    <h3 class="h5 mt-4 mb-3">Dein Event-Packet</h3>

                    <div class="card">
                        <ul class="list-group list-group-flush">

                            <li class="list-group-item p-0">

                                <div class="row no-gutters align-items-center p-3">
                                    <div class="col-5">
                                        <img :src="selected.image || fallback_image" :alt="selected.title.rendered" class="img-fluid">
                                    </div>
                                    <div class="col-15 px-3">
                                        <h4 class="card-title mb-1" v-html="selected.title.rendered"></h4>
                                        <div class="card-text" v-html="selected.content.rendered"></div>
                                    </div>
                                    <div class="col-4 text-right">
                                        <button @click="selected=null;completed=false" type="button" class="btn btn-sm text-info">
                                            <i class="juh-icon juh-icon-edit"></i>
                                        </button>
                                    </div>
                                </div>


                            </li>

                        </ul>
                    </div>

                    <h3 class="h5 mt-4 mb-3">Event</h3>

                    <div class="form-group">
                        <input type="text" v-model="form_fields.type" placeholder="Was für ein Event?" class="form-control">
                    </div>

                    <div class="form-group">
                        <input type="text" v-model="form_fields.when" @focus="text2Date" placeholder="Wann?" class="form-control">
                    </div>

                    <div class="form-group">
                        <input type="text" v-model="form_fields.where" placeholder="Wo?" class="form-control">
                    </div>

                    <div class="form-group">
                        <input type="text" v-model="form_fields.people_count" placeholder="Wie viele Personen?" class="form-control">
                    </div>

                    <h3 class="h5 mt-4 mb-3">Kontakt</h3>

                    <div class="form-group">
                        <input v-model="form_fields.contact_person" v-validate="'required'" :class="{'is-invalid': errors.has('contact_person')}" type="text" name="contact_person" placeholder="Ansprechpartner *" class="form-control">
                    </div>

                    <div class="form-group">
                        <input v-model="form_fields.email" v-validate="'required|email'" :class="{'is-invalid': errors.has('email')}" type="email" name="email" placeholder="E-Mail *" class="form-control">
                    </div>

                    <div class="form-group">
                        <input type="tel" v-model="form_fields.phone" placeholder="Telefon" class="form-control">
                    </div>

                    <div class="form-group">
                        <textarea v-model="form_fields.message" placeholder="Deine Nachricht an uns..." rows="4" class="form-control"></textarea>
                    </div>

                    <div class="form-group">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" v-model="form_fields.privacy" name="privacy" id="privacy" v-validate="'required'" :class="{'is-invalid': errors.has('privacy')}">
                            <label class="custom-control-label" for="privacy" :class="{'is-invalid': errors.has('privacy')}">Hiermit stimme ich den <a :href="privacy_link" target="_blank" rel="noopener">Datenschutzbestimmungen</a> zu.</label>
                        </div>
                    </div>

                    <div class="form-group">

                        <button type="button" class="btn btn-lg btn-block btn-primary" @click="submit" :class="{disabled: sending == true}">
                            <span v-if="sending == true">
                                <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                Anfrage wird gesendet...
                            </span>
                            <span v-if="!sending == true">
                                Anfrage senden
                            </span>
                        </button>

                    </div>

                </div>
            </div>

        </form>

        <div v-if="completed" class="alert alert-success text-center">
            Vielen Danke für deine unverbindliche Event-Buchung.
        </div>

        <div v-show="!packages.length" class="text-center">
            <div class="spinner-border text-secondary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props: {
        itemClass: String
    },
    data () {
        return {
            ajax_url: wp_ajax_url,
            privacy_link: wp_privacy_url,
            wp_url: wp_url,
            fallback_image: fallback_image,
            loading: true,
            sending: false,
            packages: [],
            selected: null,
            completed: false,
            form_fields: {
                type: '',
                when: '',
                where: '',
                people_count: '',
                contact_person: '',
                email: '',
                phone: '',
                message: '',
                privacy: false
            }
        }
    },

    mounted() {
        this.getPackages();
    },

    methods: {

        getPackages() {

            var $this = this,
                data = {per_page: 100};

            $.getJSON(wp_url + '/wp-json/wp/v2/event_package', data, function(packages){
                $this.packages = packages;
                $this.loading = false;
            });

        },

        text2Date(e) {
            e.target.type = 'date';
        },

        submit() {

            var $this = this;

            $this.$validator.validate().then(function(valid) {

                if( valid === true ) {

                    $this.sending = true;

                    var data = Object.assign({
                        action:     'send_booking',
                        id:         $this.selected.id,
                        title:      $this.selected.title.rendered,
                        content:    $this.selected.content.rendered,
                        link:       $this.selected.link,
                    }, $this.form_fields);

                    $.post($this.ajax_url, data, function(response){

                        $this.sending       = false;
                        $this.completed     = true;
                        $this.selected      = null;
                        $this.form_fields   = {
                            type: '',
                            when: '',
                            where: '',
                            people_count: '',
                            contact_person: '',
                            email: '',
                            phone: '',
                            message: '',
                            privacy: false
                        };

                        window.scrollTo(0, 0);

                    });

                } else {

                    window.scrollTo(0, 0);

                }

            }).catch(function(error){

                $this.sending = false;

                // console.log(error);

                window.scrollTo(0, 0);

            }).then(function(){

                // $this.sending = false;

                // console.log($this.sending);

            });

            return;

        }

    }
}
</script>

<style lang="scss"></style>
